<script setup lang="ts">
import {LegacyOrder, legacyOrderCommands, legacyOrderKey, useContext, useLocalization} from '@hantera/portal-app';
import {inject, ref, watch} from 'vue';
import useBackend from '@/composition/useBackend';
import {ElasticInput} from "@hantera/design-system";

const order = inject(legacyOrderKey, ref<LegacyOrder>(<any>{}));
const t = useLocalization();
const { legacyOrders: orders } = useBackend();
const context = useContext();

const notes = ref(order.value.comments);
watch(() => order.value.comments, (val) => {
  notes.value = val;
});

watch(() => notes.value, async () => {
  if (order.value.comments.trim() === notes.value.trim()) {
    return;
  }

  await orders.buildCommandGroup(order.value.orderId, "Update notes", {})
    .command(
      legacyOrderCommands.upsertOrderField, {
        fieldKey: 'Comments',
        fieldValue: notes.value,
      })
    .command(legacyOrderCommands.addActivityLog, {
      message: "Note: {note}",
      fields: {
        note: notes.value.trim(),
      },
    })
    .send();
})

</script>

<template>
  <div>
    <div class="box-content-label">
      {{t('orderView.notes.label')}}
    </div>

    <ElasticInput
      v-model.lazy="notes"
      :placeholder="t('orderView.notes.placeholder')"
      class="box-pop"
      :class="{
        'notes__textarea--empty': !notes.trim(),
        'notes__textarea--has-value': notes.trim(),
      }"
    />
  </div>
</template>

<style scoped>
.notes__textarea {
  padding: 5px;
}
</style>